export default __webpack_public_path__ + "static/media/afterparty-event-row.72037b55.jpg";